import { Tooltip } from '@sgme/ui';
import { useReadFromClipboard } from 'hooks/useReadFromClipboard';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { DropdownItem } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { essentialImportQuotesThunk } from 'state/essential/thunks';

function useImportQuote() {
  const dispatch = useThunkDispatch();
  const { isAvailable, readCellsAsFlatArray } = useReadFromClipboard();

  const isImportQuoteEnabled = isAvailable();

  const onImportQuoteClicked = async () => {
    const identifiers = await readCellsAsFlatArray(true);
    dispatch(essentialImportQuotesThunk(identifiers));
  };

  return { isImportQuoteEnabled, onImportQuoteClicked };
}

export function ImportQuoteDropdownItem() {
  const { isImportQuoteEnabled, onImportQuoteClicked } = useImportQuote();

  return (
    <Tooltip
      position="bottom"
      contents={
        <FormattedMessage
          id={
            isImportQuoteEnabled
              ? 'essential.workspace.quote.import.tooltip'
              : 'essential.workspace.quote.import.tooltip.unsupported'
          }
        />
      }
      color={isImportQuoteEnabled ? undefined : 'info'}
    >
      <DropdownItem onClick={onImportQuoteClicked} role="menuitem" as="button" disabled={!isImportQuoteEnabled}>
        <FormattedMessage id="essential.workspace.import.quote.btn" />
      </DropdownItem>
    </Tooltip>
  );
}
